<template>
  <div class="userInfo">
    <!-- 个人资料-->
    <div class="userInfo-title">{{$t('userinfo.personaldata')}}</div>
    <!-- 头像-->
    <div class="avatar">
      <div class="avatar-avatar"
           @mouseleave="editAvatar"
           @mouseenter="editAvatar">
        <!-- 显示的头像-->
        <img class="avatar-img" :src="form.avatar">
        <!-- 鼠标移入 编辑头像 -->
        <el-upload
            v-if="showEditAvatar"
            class="avatar-avatar"
            action="/api/file/upload"
            :show-file-list="false"
            :accept="acceptType"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
          <div class="avatar-editImg">
            <img :src="`${$g.imgPrefix}/img/userInfo/edit.svg`">
          </div>
        </el-upload>
      </div>
      <!-- 点击图片进行编辑-->
      <div class="avatar-text">{{$t('userinfo.clickimage')}}</div>
    </div>
    <el-form :model="form" ref="formRef" class="operate">
      <!-- 昵称-->
      <div class="operate-box">
        <div class="operate-title">{{$t('userinfo.nickname')}}</div>
        <div v-if="!editNickName" class="operate-before">
          <div class="operate-before-name">{{ form.name }}</div>
          <!-- 编辑-->
          <div class="edit" @click="editItem('editNickName')">{{$t('userinfo.edit')}}</div>
        </div>
        <div v-else class="operate-after">
          <el-form-item class="operate-after-edit" prop="name">
            <el-input v-model="form.name"
                      v-no-head-space
                      v-no-tail-space
                      type="text"
                      placeholder=""
                      maxlength="30"
                      show-word-limit/>
            <!-- 取消-->
            <div class="edit" @click="cancelNickName('editNickName')">{{$t('friends.cancel')}}</div>
          </el-form-item>
          <!--  保存-->
          <el-button class="green-btn-sm" :disabled="disabledUpdateName" @click="saveData({name:form.name},'editNickName')">{{$t('userinfo.save')}}</el-button>
        </div>
      </div>
      <!-- 登录邮箱-->
      <div class="operate-box">
        <!-- AlongShare登录邮箱-->
        <div class="operate-title">{{$t('userinfo.alongshareloginemail')}}</div>
        <div class="operate-before">
          <div class="operate-before-name">{{ form.email }}</div>
        </div>
      </div>
      <!-- 重设密码-->
      <div class="operate-box">
        <!-- 重设密码-->
        <div class="operate-title">{{$t('userinfo.resetpassword')}}</div>
        <div v-if="!editPassword" class="operate-before">
          <!-- 编辑密码-->
          <div class="operate-before-name">{{$t('userinfo.editpassword')}}</div>
          <!-- 编辑-->
          <div class="edit" @click="editItem('editPassword')">{{$t('userinfo.edit')}}</div>
        </div>
        <div v-else class="operate-after">
          <el-form-item class="operate-after-edit" prop="password">
            <el-input v-model.trim="form.password"
                      type="text"
                      :placeholder="$t('userinfo.currentpassword')"
                      maxlength="20"
                      show-word-limit/>
            <!-- 取消-->
            <div class="edit" @click="cancelPass('editPassword')">{{$t('friends.cancel')}}</div>
          </el-form-item>
          <el-form-item class="operate-after-edit" prop="newPassword">
            <el-input v-model.trim="form.newPassword"
                      @input="changeNewPassword"
                      type="text"
                      :placeholder="$t('userinfo.newpassword')"
                      maxlength="20"
                      show-word-limit/>
          </el-form-item>
          <!-- 密码要求说明-->
          <div class="operate-after-desc">
            <!--  您的密码必须具有-->
            <div class="operate-after-text">{{$t('userinfo.passwordmust')}}</div>
            <div class="operate-after-text ">
              <img :src="`${$g.imgPrefix}/img/userInfo/right.svg`">
              <!-- 任意字母，数字，特殊字符-->
              <span :class="newPassValid==1?'red-text-1':(newPassValid==2?'green-text-2':'')">{{$t('userinfo.anycharacter')}}</span>
            </div>
            <div class="operate-after-text">
              <img :src="`${$g.imgPrefix}/img/userInfo/right.svg`">
              <!--  您输入的两个密码相同-->
              <span :class="confirmPassValid==1?'red-text-1':(confirmPassValid==2?'green-text-2':'')">{{$t('userinfo.twosamepasswords')}}</span>
            </div>
          </div>
          <!-- 确认密码-->
          <el-form-item class="operate-after-edit" prop="confirmPassword">
            <el-input v-model.trim="form.confirmPassword"
                      @input="changeConfirmPassword"
                      type="text"
                      :placeholder="$t('userinfo.confirmpassword')"
                      maxlength="20"
                      show-word-limit/>
          </el-form-item>
          <!-- 更新密码-->
          <el-button
              class="green-btn-sm"
              :disabled="disabledUpdatePass"
              @click="updatePassword">{{$t('userinfo.updatepassword')}}</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  getUserInfo,
  MessageError,
  isEmpty,
  formatObj,
  MessageSuccess
} from "@/util/util";
import {
  isPassword
} from "@/util/validate";
import {
  getUserByid,
  updatePwd,
  updateUserById
} from "@/request/requests";

export default {
  name: "userinfo",
  data() {
    return {
      showEditAvatar: false,
      acceptType: '.jpg,.png,.jpeg',
      editNickName: false,
      editPassword: false,
      //新密码校验是否通过：未填写0  已填写未通过校验1  已填写通过校验2
      newPassValid: 0,
      //确认密码校验是否通过：未填写0  已填写未通过校验1  已填写通过校验2
      confirmPassValid: 0,
      userinfo:"",
      defaultAvatar: `${this.$g.imgPrefix}/img/header/Group1000005849@2x.webp`,
      form: {
        //头像
        avatar: '',
        //昵称
        name: '',
        //邮箱
        email:'',
        //当前密码
        password: '',
        //新密码
        newPassword: '',
        //确认密码
        confirmPassword: ''
      },
    }
  },
  computed:{
    disabledUpdateName(){
      let flag = true;
      if(!this.isEmpty(this.form.name)){
        flag = false;
      }
      return flag;
    },
    disabledUpdatePass(){
      let flag = true;
      if((!this.isEmpty(this.form.newPassword) && this.newPassValid == 2)
          &&(!this.isEmpty(this.form.confirmPassword) && this.confirmPassValid == 2)
          && !this.isEmpty(this.form.password)){
        flag = false;
      }
      return flag;
    }
  },
  methods: {
    isEmpty,
    async updatePassword(){
      let data = {
        email: this.form.email,
        password: this.form.newPassword
      };
      let res = await updatePwd(data);
      if(res.status=='200'){
        MessageSuccess(res.msg);
        this.editPassword = !this.editPassword;
      }else{
        MessageError(res.msg)
      }
    },
    async getUserByidInfo() {
      let res = await getUserByid(this.userinfo.id)
      if (res.status == "200") {
        //头像
        if (this.isEmpty(res.data.avatar)){
          this.form.avatar = this.defaultAvatar;
        }else{
          this.form.avatar = res.data.avatar;
        }
        this.form.name = res.data.name;
        this.form.email = res.data.email;
      } else {
        MessageError(res.msg)
      }
    },
    async saveData(obj,editFlag) {
      let params = formatObj(obj);
      let res = await updateUserById(params)
      if (res.status == "200") {
        this.getUserByidInfo();
        this[editFlag] = false;
        MessageSuccess(res.msg)
      } else {
        MessageError(res.msg)
      }
    },
    changeConfirmPassword(corfirmPass) {
      //新密码栏位是空
      if (this.isEmpty(corfirmPass)) {
        //校验通过：文言灰色
        this.confirmPassValid = 0;
        return
      }
      //确认密码校验规则判断
      if (corfirmPass != this.form.newPassword) {
        //校验不通过：文言红色
        this.confirmPassValid = 1;
      } else {
        //校验通过：文言绿色
        this.confirmPassValid = 2;
      }
    },
    changeNewPassword(newPass) {
      //新密码栏位是空
      if(this.isEmpty(newPass)){
        //校验通过：文言灰色
        this.newPassValid = 0;
        return
      }
      //新密码不为空 需要校验密码规则
      if(!isPassword(newPass)){
        //校验不通过：文言红色
        this.newPassValid = 1;
      }else{
        //校验通过：文言绿色
        this.newPassValid = 2;
      }


      //确认密码
      this.changeConfirmPassword(this.form.confirmPassword)
    },
    editItem(flag) {
      this[flag] = true;
    },
    cancelNickName() {
      this.editNickName = false;
      this.$set(this.form, 'name', this.userInfo.name);
    },
    cancelPass() {
      this.editPassword = false;
      this.form.password = '';
      this.form.newPassword = '';
      this.form.confirmPassword = '';
    },
    editAvatar() {
      this.showEditAvatar = !this.showEditAvatar;
    },
    handleAvatarSuccess(res, file) {
      if (res.status == "200") {
        this.form.avatar = res.data;
        let params = {
          avatar: this.form.avatar
        }
        this.saveData(params)
      } else {
        MessageError(res.msg)
      }
      console.log(file)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        // this.$message.error('Uploaded pictures can only be in JPG | png format');
        // this.$message.error('업로드된 사진은 JPG | png 형식만 가능합니다.');
        this.$message.error(this.$t('userinfo.onlyjpgpng'));
      }
      if (!isLt5M) {
        // this.$message.error('The size of the uploaded image cannot exceed 5MB!');
        // this.$message.error('업로드된 이미지의 크기는 5MB를 초과할 수 없습니다!!');
        this.$message.error(this.$t('userinfo.cannotexceed'));
      }
      return isJPG && isLt5M;
    },

  },
  mounted(){
    let userInfo = getUserInfo();
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
      this.getUserByidInfo();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/userInfo.scss";
</style>